import { apiClient } from "@/services/services";
import type { AxiosResponse } from "axios";
import type { SearchResult } from "@/types/searchResult";

export async function lookUp(
  apiEndpoint: string,
  searchTerm: string,
  locale: string
): Promise<SearchResult[]> {
  const response: AxiosResponse = await apiClient.get(
    `${apiEndpoint}DestinationSearch/Search?s=${searchTerm}&culture=${locale}`
  );

  return response.data ?? [];
}
